var map = {
	"./cave.js": [
		"3105",
		"chunk-54da03cf"
	],
	"./only_kannada.js": [
		"e909",
		"chunk-dfd8a6ce"
	],
	"./precave.js": [
		"f74f",
		"chunk-74f991af"
	],
	"./rokkt.js": [
		"a369",
		"chunk-0d0c5399"
	],
	"./vlite-gogo.js": [
		"5025",
		"chunk-7f396950"
	],
	"./vlite.js": [
		"b4ad",
		"chunk-353e4619"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a0b7";
module.exports = webpackAsyncContext;